import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Slider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./index.scss";
import { TranslateProvider, useTranslation } from "../i18n";

function VRSlider({
  isShow = false,
  onClose,
  name,
  folder,
  totalSlides,
  langCode = "en"
}) {
  const {
    _t,
    setLanguage
  } = useTranslation();
  useEffect(() => {
    setLanguage(langCode);
  }, [langCode, setLanguage]);
  const [slide, setSlide] = useState(1);
  const [slides, setSlides] = useState({});

  function switchSlides(e, newValue) {
    setSlide(newValue);
  }

  function closeSlider() {
    // Reset all static values
    setSlide(1);
    setSlides({}); // Close sliderVR

    onClose();
  }

  useEffect(() => {
    if (isShow && folder) {
      let slidesForLoad = {};

      for (let x = 1; x <= totalSlides; x++) {
        slidesForLoad[`slide_${x}`] = require(`../mediaContent/VRSlides/${folder}/img/${x}.png`);
      }

      setSlides({});
      Object.keys(slidesForLoad).forEach((id, index) => {
        imgLoader(slidesForLoad[id]).then(src => {
          setSlides(prevSlides => ({ ...prevSlides,
            [id]: src
          }));
        });
      });
    }
  }, [isShow, folder, totalSlides]); // Set slides according to slides amount and cords x and y

  const [currentSlide, setCurrentSlide] = useState(null);
  useEffect(() => {
    const slideKey = `slide_${slide}`;
    let slideSrc = slides.hasOwnProperty(slideKey) ? slides[slideKey] : null;
    setCurrentSlide(slideSrc);
  }, [slides, slide]);

  if (!isShow) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "sliderVR"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sliderVR-backdrop",
    onClick: closeSlider
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    size: "small",
    className: "sliderVR-close",
    onClick: closeSlider,
    endIcon: /*#__PURE__*/React.createElement(CloseIcon, null)
  }, _t("Закрыть")), /*#__PURE__*/React.createElement("div", {
    className: "sliderVR-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sliderVR-container-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sliderVR-container-title-wrapper"
  }, name)), /*#__PURE__*/React.createElement("img", {
    className: "sliderVR-container-img",
    src: currentSlide,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "sliderVR-container-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sliderVR-container-controls-wrapper"
  }, /*#__PURE__*/React.createElement(Slider, {
    defaultValue: 1,
    marks: true,
    min: 1,
    max: totalSlides,
    onChange: switchSlides
  })))));
}

VRSlider.propTypes = {
  isShow: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  folder: PropTypes.string.isRequired,
  totalSlides: PropTypes.number.isRequired
};

function imgLoader(src) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = src;

    img.onload = function () {
      resolve(src);
    };

    img.onerror = function () {
      reject();
    };
  });
}

const VRSliderWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(VRSlider, props));
};

export default VRSliderWrapper;